// src/components/ContactUsForm.jsx
import React, { useState, Fragment } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import { sendContactForm } from "../../api/Contactapi";

const initialState = {
  full_name: "",
  email: "",
  phone: "",
  service: "",
  message: "",
};

const ContactUsForm = () => {
  const [formData, setFormData] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState(null);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const e = {};
    if (!formData.full_name?.trim()) e.full_name = "Full name is required";
    if (!formData.email?.trim()) e.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      e.email = "Invalid email format";
    if (!formData.message?.trim()) e.message = "Message is required";
    return e;
    // Phone & service optional, chaho to yahan rules add karo
  };

  const handleChange = (e) => {
    setFormData((s) => ({ ...s, [e.target.name]: e.target.value }));
    setErrors((prev) => ({ ...prev, [e.target.name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setResponseMsg(null);

    // Basic validation
    const v = validate();
    if (Object.keys(v).length) {
      setErrors(v);
      return;
    }

    setLoading(true);
    try {
      const response = await sendContactForm(formData);
      setLoading(false);

      if (response?.status) {
        setResponseMsg({ type: "success", text: response?.message || "Submitted!" });
        setFormData(initialState);
      } else {
        const text =
          typeof response?.errors === "string"
            ? response.errors
            : JSON.stringify(response?.errors || "Submission failed");
        setResponseMsg({ type: "error", text });
      }
    } catch (err) {
      setLoading(false);
      setResponseMsg({ type: "error", text: "Something went wrong!" });
    }
  };

  return (
    <Fragment>
      <Container>
        <Row style={{ paddingTop: "70px", paddingBottom: "70px" }}>
          {/* Left Section - Contact Info */}
          <Col lg={5} md={6} sm={12} className="contact_detail">
            <div className="contact_box">
              <h1 className="contact_heading">Get in Touch With Us Today</h1>
              <p className="contact_description">
                We’re always happy to hear from you! Whether you have questions,
                feedback, or want to learn more about our services, our team is
                ready to assist. Fill out the form below and we’ll get back to
                you as soon as possible.
              </p>
              <ul className="contact-info">
                <li className="icon-box">
                  <div className="icon-circle">
                    <FaPhoneAlt />
                  </div>
                  <span className="info-text">+92-333-585550-2</span>
                </li>
                <li className="icon-box">
                  <div className="icon-circle">
                    <FaEnvelope />
                  </div>
                  <span className="info-text">info@sparklabpk.com</span>
                </li>
                <li className="icon-box">
                  <div className="icon-circle" style={{ width: "11rem" }}>
                    <FaMapMarkerAlt />
                  </div>
                  <span className="info-text">
                    Plot No. 18D, Floor 2, Nishat Commercial, Lane 4, D.H.A Phase 6 Defence Housing Authority, Karachi, 75500
                  </span>
                </li>
              </ul>
            </div>
          </Col>

          {/* Right Section - Contact Form */}
          <Col lg={7} md={6} sm={12}>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="contact-form-wrapper">
                <div className="glass-form">
                  {/* Full Name */}
                  <div className="mb-3">
                    <label className="form-label text-light">Full Name</label>
                    <input
                      type="text"
                      name="full_name"
                      className="form-control contact-input"
                      placeholder="Enter your name"
                      value={formData.full_name}
                      onChange={handleChange}
                    />
                    {errors.full_name && (
                      <small style={{ color: "salmon" }}>{errors.full_name}</small>
                    )}
                  </div>

                  {/* Email */}
                  <div className="mb-3">
                    <label className="form-label text-light">Email Address</label>
                    <input
                      type="email"
                      name="email"
                      className="form-control contact-input"
                      placeholder="Enter your email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {errors.email && (
                      <small style={{ color: "salmon" }}>{errors.email}</small>
                    )}
                  </div>

                  {/* Phone */}
                  <div className="mb-3">
                    <label className="form-label text-light">Phone Number</label>
                    <input
                      type="tel"
                      name="phone"
                      className="form-control contact-input"
                      placeholder="+92 300 1234567"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>

                  {/* Services */}
                  <div className="mb-3">
                    <label className="form-label text-light">Services</label>
                    <input
                      type="text"
                      name="service"
                      className="form-control contact-input"
                      placeholder="Enter service you are interested in"
                      value={formData.service}
                      onChange={handleChange}
                    />
                  </div>

                  {/* Message */}
                  <div className="mb-3">
                    <label className="form-label text-light">Message</label>
                    <textarea
                      rows="4"
                      name="message"
                      className="form-control contact-input"
                      placeholder="Write your message..."
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>
                    {errors.message && (
                      <small style={{ color: "salmon" }}>{errors.message}</small>
                    )}
                  </div>

                  {/* Submit */}
                  <button
                    type="submit"
                    className="btn contact-btn w-100"
                    style={{ background: "white" }}
                    disabled={loading}
                  >
                    {loading ? "Sending..." : "Send Message"}
                  </button>

                  {/* Response message */}
                  {responseMsg && (
                    <p
                      style={{
                        marginTop: "10px",
                        color: responseMsg.type === "error" ? "red" : "lightgreen",
                        wordBreak: "break-word",
                      }}
                    >
                      {responseMsg.text}
                    </p>
                  )}
                </div>
              </div>
            </form>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default ContactUsForm;
